<template>
  <div>
    <div v-if='damageList.length' class='damage-review__title'>Добавленные повреждения</div>

    <div class='damage-review__damage-container'>
      <div v-for='damage in damageList' :key='damage' @click='removeDamage(damage)' class='damage-review__damage-box'>
        <div>{{ damage }}</div>
        <fa-icon icon='times'/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecountTreesDamageDamagesReview',

  props: {
    addingTree: Object,
    groupedDamageList: Object
  },

  computed: {
    damageList: {
      get() {
        const damageStrList = [];

        for (const reason_id of Object.keys(this.groupedDamageList)) {
          const symptomList = [];

          for (const damage of this.groupedDamageList[reason_id]) {
            symptomList.push(damage.symptom.id);
          }

          const damageStrTemp = `${reason_id}(${symptomList.join(', ')})`;
          damageStrList.push(damageStrTemp);
        }

        return damageStrList;
      },
      set() {}
    },
  },
  
  methods: {
    removeDamage(damage) {
      const reason_id = parseInt(damage);

      if (isNaN(reason_id)) {
        return;
      }

      this.$emit('remove-damage', reason_id);
    }
  }

};
</script>

<style scoped>
  .damage-review__title {
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  .damage-review__damage-container {
    display: flex;
    gap: 1.5rem;
  }

  .damage-review__damage-box {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    padding: 0.2rem;
    border: 1px solid transparent;
  }

  .damage-review__damage-box:hover {
    border: 1px solid red;
    color: red;
    border-radius: 4px;
  }
</style>